/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".Rechazado[_ngcontent-%COMP%] {\r\n    background:rgba(224, 55, 55, 0.5);\r\n    cursor: pointer;\r\n}\r\n.Pre-Ingresado[_ngcontent-%COMP%] {\r\n    background:rgba(235, 223, 66, 0.5);\r\n    cursor: pointer;\r\n\r\n}\r\n.Ingresado[_ngcontent-%COMP%] {\r\n    background:rgba(128, 235, 66, 0.5);\r\n    cursor: pointer;\r\n\r\n}"];
export { styles as styles };
